import React from 'react';
import SalesLeadForm from './pages/SalesLeadForm/SalesLeadForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <SalesLeadForm />
    </div>
  );
}

export default App;
